import { stepsSlider } from './modules/steps_slider';
import { feedback } from './modules/feedback';
import { showMoreCases } from './modules/show_more_cases';
import { showServices } from './modules/show_services';
import { burger } from './modules/burger';
import { modal } from './modules/modal';
import { fixedHeader } from './modules/fixed_header';
import { cities } from './modules/cities';
import { aboutSlider } from './modules/about_slider';
import { fixedBtn } from './modules/fixed_btn';
import { map } from './modules/map';
// import { geoip } from './modules/geoip';
import { goals } from './modules/goals';
import { stickyBlock } from './modules/sticky';
import { servicesCategory } from './modules/services_category';
import { servicesAbout } from './modules/services_about';
import { faq } from './modules/faq';
import { servicesAnchor } from './modules/services_anchor';
import { aboutUs } from './modules/about_us';
import { cookiesNotice } from './modules/cookies_notice';
import { addPrivacy } from './modules/add_privacy';
import { worktime } from './modules/worktime';
import { showCommand } from './modules/show_command';
import { fakeLinks } from './modules/fake_links';
import { contactsSlider } from './modules/contacts_slider';
import { diplomasSlider } from './modules/diplomas_slider';
import { showMassMedia } from './modules/show_mass_media';
import { modalGallery } from './modules/modal_gallery';
import { modalVideo } from './modules/modal_video';
import { servicesNote } from './modules/services_note';
import { reviews } from './modules/reviews';
import { footerList } from './modules/footer_list';
import { servicesTable } from './modules/services_table.js';
import { servicesContents } from './modules/services_contents.js';
import { blogPage } from './modules/blog_page';
import { dropdownNav } from './modules/dropdown_nav';
import { bankrot } from './modules/bankrot';
import { bilet } from './modules/bilet';

document.addEventListener('DOMContentLoaded', function () {
    cities();
    stepsSlider();
    feedback();
    showMoreCases();
    showServices();
    burger();
    modal();
    fixedHeader();
    aboutSlider();
    fixedBtn();
    map();
    // geoip();
    goals();
    stickyBlock();
    servicesCategory();
    servicesAbout();
    faq();
    servicesAnchor();
    aboutUs();
    cookiesNotice();
    addPrivacy();
    worktime();
    showCommand();
    fakeLinks();
    contactsSlider();
    diplomasSlider();
    showMassMedia();
    modalGallery();
    modalVideo();
    servicesNote();
    reviews();
    footerList();
    servicesTable();
    servicesContents();
    blogPage();
    dropdownNav();
    bankrot();
    bilet();
})
